export const UPDATE_FIELD = 'CONTACT_US/UPDATE_FIELD';
export const SEND_MESSAGE_START = 'CONTACT_US/SEND_MESSAGE_START';
export const SEND_MESSAGE_SUCCESS = 'CONTACT_US/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'CONTACT_US/SEND_MESSAGE_FAILURE';
export const RESET_FORM = 'CONTACT_US/RESET_FORM';
